import {NgModule} from '@angular/core';
import {ProgressHandlerFactory} from "./ProgressHandlerFactory";

@NgModule({
    providers: [ProgressHandlerFactory],
})
export class ProgressionModule {}